(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k9-home-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('k9-product-carousel')) {
    customElements.define(
      'k9-product-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-k9-carousel-track]');
          this.previous = this.querySelector('[data-k9-carousel-previous]');
          this.next = this.querySelector('[data-k9-carousel-next]');
          if (!this.track || !this.previous || !this.next) return;

          this.previous.addEventListener('click', () => this.move(-1));
          this.next.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          new ResizeObserver(() => this.update()).observe(this.track);
          this.update();
        }

        move(direction) {
          this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
        }

        update() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
// Progressive enhancement: without JavaScript, each notice remains readable as a disclosure.
if (!customElements.get('k9-launch-updates')) {
  customElements.define('k9-launch-updates', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.entries = [];
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), {
          once: true, signal: this.controller.signal
        });
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (!this.isConnected || this.entries.length ||
          typeof HTMLDialogElement === 'undefined' ||
          typeof HTMLDialogElement.prototype.showModal !== 'function') return;

      const options = { signal: this.controller.signal };
      this.querySelectorAll('details[data-k9-notice]').forEach((details) => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('[data-k9-notice-content]');
        const heading = content.querySelector('[data-k9-notice-heading]');
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'k9-launch-updates__trigger';
        trigger.innerHTML = summary.innerHTML;
        trigger.setAttribute('aria-haspopup', 'dialog');

        const dialog = document.createElement('dialog');
        dialog.id = details.id + '-dialog';
        dialog.className = 'k9-news-dialog';
        dialog.setAttribute('aria-labelledby', heading.id);
        trigger.setAttribute('aria-controls', dialog.id);

        const toolbar = document.createElement('div');
        toolbar.className = 'k9-news-dialog__toolbar';
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'k9-news-dialog__close';
        close.textContent = '閉じる ×';
        close.setAttribute('aria-label', 'お知らせを閉じる');
        toolbar.append(close);
        dialog.append(toolbar, content);
        this.append(dialog);
        details.before(trigger);
        details.hidden = true;
        this.entries.push({ details, content, dialog, trigger });

        trigger.addEventListener('click', () => {
          if (dialog.open) return;
          dialog.showModal();
          content.scrollTop = 0;
          heading.focus({ preventScroll: true });
        }, options);
        close.addEventListener('click', () => dialog.close(), options);
        // Escape uses the native dialog cancel/close behavior, including its focus trap.
        dialog.addEventListener('close', () => {
          if (this.isConnected) trigger.focus({ preventScroll: true });
        }, options);

        const isBackdrop = (event) => {
          if (event.target !== dialog) return false;
          const rect = dialog.getBoundingClientRect();
          return event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom;
        };
        let startedOnBackdrop = false;
        dialog.addEventListener('pointerdown', (event) => {
          startedOnBackdrop = isBackdrop(event);
        }, options);
        dialog.addEventListener('click', (event) => {
          if (startedOnBackdrop && isBackdrop(event)) dialog.close();
          startedOnBackdrop = false;
        }, options);
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      for (const { details, content, dialog, trigger } of this.entries || []) {
        if (dialog.open) dialog.close();
        details.append(content);
        details.hidden = false;
        trigger.remove();
        dialog.remove();
      }
      this.entries = [];
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
